const actions = {
  UPDATE_ATTENDEES_LIST: "UPDATE_ATTENDEES_LIST",
  HOST_MUTE_ALL: "HOST_MUTE_ALL",
  HOST_UNMUTE_ALL: "HOST_UNMUTE_ALL",
  UPDATE_ATTENDEES_MAP: "UPDATE_ATTENDEES_MAP",
  SET_LOADING_HOST_MUTE_ALL: "SET_LOADING_HOST_MUTE_ALL",
};

export default actions;
